import React from 'react'
import { useTranslation } from 'react-i18next'
import { BuildingCharacteristics } from '@popety-io/ui'
import { useClearMapSection } from '../hooks'

interface BuildingTabProps {
  estimateData: any
}

export const BuildingTab: React.FC<BuildingTabProps> = ({ estimateData }) => {
  const { t } = useTranslation('characteristics')

  // Clear map section data when viewing building tab
  useClearMapSection()

  // Match main app data path: value_edited.building || value.buildings[0]
  const building =
    estimateData?.value_edited?.building || estimateData?.value?.buildings?.[0]

  // Get pre-fetched neighborhood analysis if available (read-only)
  const neighborhoodAnalysis = estimateData?.value_edited?.neighborhoodAnalysis

  return (
    <BuildingCharacteristics
      building={building}
      loading={!estimateData}
      error={
        !building ? t('states.noData', 'No building data available') : null
      }
      t={t}
      initialNeighborhoodAnalysis={neighborhoodAnalysis}
      // Read-only mode: no callbacks for editing
    />
  )
}
